import { useContext } from 'react';
import VideoWrapper from './VideoWrapper';
import { StoreContext } from './StoreProvider';
import useCssUrl from './hooks/useCssUrl';

const App = () => {
    const { customerData, settings } = useContext(StoreContext);
    const cssUrl = useCssUrl();

    return (
        <div className="video__wrapper">
            {settings && customerData ? (
                <>
                    <VideoWrapper />
                    <link href={cssUrl} rel="stylesheet" />
                </>
            ) : null}
        </div>
    );
}

export default App;
